// ATLAS screen help (the "?" at the top of ATLAS). Plain words; keep it in step with
// the screen — SHAPE definitions from docs/master-book/src/02-part2.md, S.T.A.G.E. time
// frames from docs/orient/ATLAS_VX_SPEC.md.
import { SECTOR_COLOR } from '../../v10/theme';
import type { ScreenHelpContent } from '../../v10/ScreenHelp';

export function atlasHelp(colors: { written: string; found: string }): ScreenHelpContent {
  return {
    title: 'ATLAS',
    intro:
      "ATLAS is where you decide what you're working toward in each part of your life, from the big direction down to the very next thing to do. It only sets things. It doesn't score you; scores are on Home.",
    sections: [
      {
        heading: 'The five areas (SHAPE)',
        body: [
          'Your life is split into five areas. Pick one in the coloured bar to work on it. What each area covers is up to you, because it means different things to different people.',
        ],
        items: [
          { term: 'Social', text: 'the people in your life: friends, family, colleagues, students, belonging.', color: SECTOR_COLOR.S },
          { term: 'Health', text: 'your body: sleep, energy, movement, food.', color: SECTOR_COLOR.H },
          { term: 'Admin', text: 'running your life: bills, paperwork, appointments, the house in order.', color: SECTOR_COLOR.A },
          { term: 'Personal', text: 'your inner life: values, growth, learning, calm.', color: SECTOR_COLOR.P },
          { term: 'Economic', text: 'work and money: earning, saving, building value.', color: SECTOR_COLOR.E },
        ],
      },
      {
        heading: 'Change the areas',
        body: [
          'In the SHAPE SECTORS panel: tap a name to rename it, use the switch to turn an area off, and press + Add to make your own.',
        ],
      },
      {
        heading: 'The ladder (S.T.A.G.E.)',
        body: ['Each area has five levels, from big to small. Each one is smaller in time than the one above it.'],
        items: [
          { term: 'Endeavour', text: '3–4 months. The direction: something you want to establish and then keep.' },
          { term: 'Goal', text: 'This month. A result that moves the Endeavour forward.' },
          { term: 'Aim', text: "This week. What you'll do this week toward the Goal. Each Aim becomes a task in KYRS when you save." },
          { term: 'Today', text: "By tonight. A result, a finish line you can tick off, not an action." },
          { term: 'Step', text: 'Right now. The actual action, something you can start in a few minutes.' },
        ],
      },
      {
        heading: 'How to fill it in',
        body: [
          'Tap a row to open its list. Picking something fills the rows below it with a suggestion; change any of them.',
          'Want something of your own? Type it in the box at the bottom of the list. For your own Endeavour, Goal, Aim or Today, ATLAS writes 10 options for the row below.',
          'Made a mistake on one of your own? Use the pencil to rename it or the bin to delete it. Built-in options stay fixed.',
          'Today and Step reset every day, so pick them fresh each morning.',
        ],
      },
      {
        heading: 'Principles',
        body: ['The short rule that keeps you going. Pick one or more.'],
        items: [
          { term: 'Yellow', text: "written for your ladder: what you're doing, so what it leads to.", color: colors.written },
          { term: 'Green', text: 'well-known principles that fit what you said.', color: colors.found },
        ],
      },
      {
        heading: 'Saving',
        body: ['Changes are kept on screen until you press Save at the bottom. Save writes them and creates your Aim tasks.'],
      },
    ],
  };
}
